export default "__VITE_ASSET__DFMywsRT__"